import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ResponseEnum } from "../../enums/ResponseEnum.enum";
import {
  IResponseLoginService
} from "../../interfaces/response-login-service";
import { IResponseService } from "../../interfaces/response-service";
import { AddressesUrlParams } from "../../parameters/addresses-url-params";
import { AuthenticationService } from "../../services/authentication.service";
import { BaseService } from "../../services/base.service";
import { NotificationService } from "../../services/notification.service";
import { SAlertComponent } from "../../shared/components/s-alert/s-alert.component";
import { OauthModel, UserModel } from "../../shared/models/user-model";
import { GetIPSevice } from "../../shared/services/getIp.service";
import { NotificationsAppService } from "../../shared/services/notifications-app.service";
import { MesaggeText } from "../../shared/texts/mesagge-text";
import { MainStore } from "../../store/main-store";
import { Utils } from "../../utils/utils";
import { MENU_ITEM } from "../menu";
import { environment } from "../../../environments/environment";
import { AuthRefreshService } from "../../shared/services/auth-refresh.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  /**
   * Variables de la vista
   */
  login: UserModel;
  constructor(
    public authService: AuthenticationService,    
    private route: Router,
    public authRefresh: AuthRefreshService    
  ) {
    let self = this;

    window["OnExpired"] = function OnExpired() {
      self._OnExpired();
    };

    MainStore.db.RestData();
    MainStore.ORIGIN = 1;
    this.login = MainStore.db.GetUser();    
  }

  ngOnInit() {
    let parent = document.getElementById("g-recaptcha");
    parent.innerHTML = `<div
      class="g-recaptcha"
      data-sitekey="${environment.keycaptcha}"
      data-callback="OnExpired"
      ></div>`;
    $(parent).addClass(" recaptcha-login");
  }

  /**
   * @author Jose Wilson Mulato
   * @description Escucha el evento del click para validar los campos y enviar la autenticación
   */
  OnClickEntry() {
    
    /*this.login.name = 'test';
    this.login.ip = window.location.hostname;
    this.login.numDoc = 94412240;
    this.LoadMenu(null);
      return this.route.navigateByUrl(AddressesUrlParams.PathIndex());
      */

    if (!this._OnExpired()) {
      return SAlertComponent.AlertWarning(MesaggeText.NOT_VALID_NOT_ROBOT);
    }    

    const msg = this.ValidateFields();
    if (!msg) {
      SAlertComponent.ShowSpinner();
      this.authService.Login(this.login).then(
        response => {
          SAlertComponent.CloseSpinner();
          this.CheckResponse(response);
        },
        error => {
          SAlertComponent.AlertError(
            MesaggeText.TITLE_ALERT,
            MesaggeText.ERROR_CONNETION
          );
        }
      );
    } else {
      SAlertComponent.AlertInfo("Alert", msg);
    }
  }

  /**
   * @author Jose Wilson Mulato
   * @description Valida la respuesta que envia el servicio
   * @param response
   */
  CheckResponse(response: IResponseService): any {
    if (response.status == ResponseEnum.OK) {
      this.LoadData(response.data);
      this.LoadMenu(response.data);
      return this.route.navigateByUrl(AddressesUrlParams.PathIndex());
    } else if (response.status == ResponseEnum.FAILURE) {
      SAlertComponent.AlertError(
        MesaggeText.TITLE_ALERT,
        response.messageError
      );
      return;
    }
  }

  /**
   * @author Jose Wilson Mulato
   * @description Carga el menu en la aplicación
   * @param data
   */
  LoadMenu(data: IResponseLoginService) {
    let actions: Array<string> = [];
    actions.push("Banco de Alimentos");
    MainStore.db.ClearMenu();
    let newList = this.FilterItemMenu(
      Utils.CopyJson(MENU_ITEM),
      actions
    );
    newList.forEach(x => MainStore.db.AddMenu(x));
  }

  /**
   * @author Jose Wilson Mulato
   * @description Filtra las opciones del menú
   * @param objs
   * @param actions
   */
  FilterItemMenu(objs: object, actions: string[]): any[] {
    let newList = [];
    for (const key in objs) {
      let pos: number = actions.findIndex(x => x == key);

      if (pos != -1) {
        let itemmenu = objs[key];
        let children = itemmenu.children;
        itemmenu.children = [];
        if (children) {
          actions.splice(pos, 1);
          itemmenu.children = this.FilterItemMenu(children, actions);
        }
        newList.push(itemmenu);
      }
    }
    return newList;
  }

  /**
   * @author Jose Wilson Mulato
   * @description Carga los datos basico del usuario que ingresa y el menu
   * @param data
   */
  LoadData(data: any): any {
    console.log("Valor de obj para data",data);    
    this.login.name = data.name;
    this.login.ip = window.location.hostname;
    this.login.numDoc = data.id;
    MainStore.db.SetUser(this.login);
  }

  /**
   * @author Jose Wilson Mulato
   * @description Valida los campos que no este vacios
   * @param msg Mensaje del error que existe
   */
  private ValidateFields(): string {
    let msg: string = "";
    if (!this.login.username) {
      msg = MesaggeText.FIELD_EMPTY_USER;
    } else if (!this.login.password) {
      msg = MesaggeText.FIELD_EMPTY_PASSWORD;
    }
    return msg;
  }
  

  /**
   * @author Jose Wilson Mulato
   * @description Habilitar o desahabilitar
   */
  _OnExpired() {
    var response = window["grecaptcha"].getResponse();
    if (response.length == 0) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts